import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Producto } from '../../../_models/producto';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import { ListaItem } from '../../../_models/lista-item';
import { Table } from 'primeng/table';
import { ProductoReferencia } from '../../../_models/producto-referencia';
import { ProductoVinculacionMinimo } from '../../../_models/producto-vinculacion-minimo';
import { ProductoVinculacionMinimoReferencia } from '../../../_models/producto-vinculacion-minimo-referencia';
import { ProductoVinculacionMinimoService } from '../../../_services/producto-vinculacion-minimo.service';
import { ProductoVinculacionMinimoReferenciaService } from '../../../_services/producto-vinculacion-minimo-referencia.service';
import {ProductosReferenciasTiposPersonas} from '../../../_models/productosreferenciastipospersonas';
import {ProductosVinculacionesMinimoTiposPersonasService} from '../../../_services/productos-vinculaciones-minimo-tipos-personas.service';
import {ProductosVinculacionesMinimoTiposPersonas} from '../../../_models/productos-vinculaciones-minimo-tipos-personas';

@Component( {
  selector: 'app-producto-referencia-minima',
  templateUrl: 'producto-referencia-minima.component.html'
} )

export class ProductoReferenciaMinimaComponent implements OnInit {

  @Input() producto: Producto;
  @Input() lisProductosReferencias: ProductoReferencia[];
  @Input() lisVinculacionTodos: ListaItem[];
  @Input() lisReferenciaTodos: ListaItem[];
  @Input() listaTiposPersonas: SelectItem[] = [];
  proVinculacionesMinimas: ProductoVinculacionMinimo[] = [];
  proVinculacionesMinimasHabilitados: ProductoVinculacionMinimo[] = [];
  proVinculacionMinimoSeleccionado: ProductoVinculacionMinimo;
  lisVinculaciones: SelectItem[] = [];
  lisReferencias: SelectItem[] = [];
  lisTipoUsoCelular: SelectItem[] = [];
  carInformacionInicial = true;
  carTabla = true;
  formulario: FormGroup;
  submitted = false;
  columnas: any[];
  guardando = false;
  busqueda: string;
  @ViewChild('dt') tabla: Table;

  private _refrescar: any;

  @Input() set refrescar( value: any ) {
    this._refrescar = value;
    if ( this._refrescar && this._refrescar.estado ) {
      if ( this.proVinculacionMinimoSeleccionado ) {
        this.cargarReferencias();
      } else if ( this.formulario ) {
        this.cargarVinculaciones();
        if ( !this.lisVinculaciones.find( y => y.value === this.f.idTipoVinculacion.value ) ) {
          this.f.idTipoVinculacion.setValue( null );
        }
      }

    }
  }

  get refrescar(): any {
    return this._refrescar;
  }


  constructor( private serListas: ListaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private conServicio: ConfirmationService,
               private serProductoVinculacionMinimo: ProductoVinculacionMinimoService,
               private serProductoVinculacionMinimoReferencia: ProductoVinculacionMinimoReferenciaService,
               private productosVinculacionesMinimoTiposPersonas: ProductosVinculacionesMinimoTiposPersonasService) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'nombreTipoUsoCelular', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOUSOCELULAR' ), sort: false },
      { field: 'nombreTipoVinculacion', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_VINCULACION' ), sort: false },
      { field: 'tipoPersona', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NATURALEZA' ), sort: false },
      { field: 'nombresReferencias', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_TIPOREFERENCIA' ), sort: false },
      { field: 'indicadorCanalAnalizamos', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_CHECKANALIZAMOS' ), sort: false },
      { field: 'indicadorCanalDigital', header: this.navServicio.buscarMensaje('PRODUCTOREFERENCIA.LBL_CHECKDIGITAL'), sort: false},
      { field: 'nroReferencias', header: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.LBL_NUMREFMIN' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.busqueda = this.navServicio.getSearch( 'producto-referencia-minima.component' );

    this.serProductoVinculacionMinimo.listadoPorProductoTodos( this.producto.idProducto ).subscribe( minimo => {
      this.proVinculacionesMinimas = minimo;
      this.registrosHabilitados();
      this.cargarVinculaciones();
      this.cargarFormulario();
      this.formatearMinimasReferencias();
      this.carInformacionInicial = false;
      this.carTabla = false;
    } );
  }

  cargarVinculaciones() {
    this.lisVinculaciones = [];
    this.lisVinculacionTodos.map( ( s: ListaItem ) => {
      if ( this.lisProductosReferencias.find( x => x.idTipoVinculacion === s.idLista && x.indicadorHabilitado ) && s.indicadorHabilitado ) {
        this.lisVinculaciones.push( { label: s.nombre, value: s.idLista } );
      }
    } );
  }

  cargarFormulario() {
    const naturaleza = [];
    if (this.proVinculacionMinimoSeleccionado && Array.isArray(this.proVinculacionMinimoSeleccionado.naturaleza) && this.proVinculacionMinimoSeleccionado.naturaleza.length > 0 ) {
      this.proVinculacionMinimoSeleccionado.naturaleza.forEach( e => {
        if ( e.indicadorHabilitado ) {
          naturaleza.push( e.idTipoPersona );
        }
      } );
    }
    this.formulario = this.fb.group( {
      idProducto: [ this.producto ? this.producto.idProducto : null, [ Validators.required ] ],
      idProductoVinculacionMinimo: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo : null ],
      idTipoVinculacion: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.idTipoVinculacion : null, [ Validators.required ] ],
      idTipoUsoTelefono: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.idTipoUsoTelefono : null, [ Validators.required ] ],
      idTipoReferencia: [ (this.proVinculacionMinimoSeleccionado && this.proVinculacionMinimoSeleccionado.referencias.length > 0) ? this.proVinculacionMinimoSeleccionado.referencias.filter( r => r.indicadorHabilitado ).map( r => {
        return r.idTipoReferencia;
      } ) : [], [Validators.required] ],
      indicadorCanalAnalizamos: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.indicadorCanalAnalizamos : false],
      indicadorCanalDigital: [this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.indicadorCanalDigital: false],
      nroReferencias: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.nroReferencias : null, [ Validators.required, Validators.maxLength( 3 ) ] ],
      indicadorHabilitado: [ this.proVinculacionMinimoSeleccionado ? this.proVinculacionMinimoSeleccionado.indicadorHabilitado : true, [ Validators.required ] ],
      idNaturaleza: [ naturaleza, [ Validators.required ] ],
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    this.guardando = true;
    if ( this.formulario.valid && this.checkAnalizamosDigital()) {
      this.carInformacionInicial = true;
      this.carTabla = true;
      const formulario = this.formulario.value;
      if ( this.validarNumeroReferencias( formulario.idTipoVinculacion, formulario.idTipoUsoTelefono, formulario.idTipoReferencia, formulario.nroReferencias ) ) {
        if ( formulario.idProductoVinculacionMinimo ) {
          this.serProductoVinculacionMinimo.actualizar( formulario ).subscribe( e => {
            this.referenciasMinimasTipoPersona(formulario.idProductoVinculacionMinimo)
            this.verificarNuevas( formulario.idTipoReferencia, formulario.idProductoVinculacionMinimo, formulario.nroReferencias, this.proVinculacionMinimoSeleccionado.referencias, formulario.indicadorCanalAnalizamos, formulario.indicadorCanalDigital,2 );
            this.actualizarMinimas( 1 );
          } );
        } else {
          let exiRegistro = this.proVinculacionesMinimas.find( x => !x.indicadorHabilitado &&
            x.idTipoVinculacion === formulario.idTipoVinculacion &&
            x.idTipoUsoTelefono === formulario.idTipoUsoTelefono);
          if ( exiRegistro ) {
            exiRegistro.nroReferencias = formulario.nroReferencias;
            exiRegistro.indicadorCanalDigital = formulario.indicadorCanalDigital;
            exiRegistro.indicadorCanalAnalizamos = formulario.indicadorCanalAnalizamos;
            exiRegistro.indicadorHabilitado = true;
            this.serProductoVinculacionMinimo.actualizar( exiRegistro ).subscribe( registro => {
              this.referenciasMinimasTipoPersona(exiRegistro.idProductoVinculacionMinimo)
              this.verificarNuevas( formulario.idTipoReferencia, exiRegistro.idProductoVinculacionMinimo, formulario.nroReferencias, exiRegistro.referencias, formulario.indicadorCanalAnalizamos, formulario.indicadorCanalDigital,1 );
              this.actualizarMinimas( 1 );
            } );
          } else {
            this.serProductoVinculacionMinimo.crear( formulario ).subscribe( registro => {
              this.referenciasMinimasTipoPersona(registro.idProductoVinculacionMinimo)
              const be = this.formatearMinimaReferenciaObjetoBulkCreacion( formulario.indicadorCanalAnalizamos ,formulario.indicadorCanalDigital ,formulario.idTipoReferencia, registro.idProductoVinculacionMinimo );
              if ( be.length > 0 ) {
                this.serProductoVinculacionMinimoReferencia.bulk( be ).subscribe( reg => {
                  this.actualizarMinimas( 1 );
                } );
              } else {
                this.actualizarMinimas( 1 );
              }
            } );
          }
        }
      } else {
        this.navServicio.setMesage( 0, {
          severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_ERRORNUMREF' )
        } );
        this.guardando = false;
        this.carInformacionInicial = false;
        this.carTabla = false;
      }
    } else {
      this.guardando = false;
    }
  }

  async referenciasMinimasTipoPersona(idProductoVinculacionMinimo: string) {
    const _data = this.formulario.value;
    const lista: ProductosVinculacionesMinimoTiposPersonas[] = [];
    if(_data.idNaturaleza.length > 0) {
      _data.idNaturaleza.forEach(n => {
        let obj = {} as ProductosVinculacionesMinimoTiposPersonas;
        obj.idProductoVinculacionMinimo = idProductoVinculacionMinimo;
        obj.idTipoPersona = n;
        obj.indicadorHabilitado = true;
        if (this.proVinculacionMinimoSeleccionado && Array.isArray(this.proVinculacionMinimoSeleccionado.naturaleza) && this.proVinculacionMinimoSeleccionado.naturaleza.length > 0) {
          const x = this.proVinculacionMinimoSeleccionado.naturaleza.find(l => l.idProductoVinculacionMinimo === idProductoVinculacionMinimo && l.idTipoPersona === n);
          if (x) {
            obj.idProductoVinculacionMininoTipoPersona = x.idProductoVinculacionMininoTipoPersona;
          }

        }
        lista.push(obj);
      });

      if (this.proVinculacionMinimoSeleccionado && Array.isArray(this.proVinculacionMinimoSeleccionado.naturaleza) && this.proVinculacionMinimoSeleccionado.naturaleza.length > 0) {
        this.proVinculacionMinimoSeleccionado.naturaleza.forEach( e => {
          if ( e.indicadorHabilitado && !_data.idNaturaleza.find( y => y === e.idTipoPersona ) ) {
            e.indicadorHabilitado = false;
            lista.push( e );
          }
        } );
      }

      if (lista.length > 0) {
        await this.productosVinculacionesMinimoTiposPersonas.bulk(lista).toPromise();
      }
    }
  }

  checkAnalizamosDigital(){
    if(!this.f.indicadorCanalAnalizamos.value && !this.f.indicadorCanalDigital.value){
      this.navServicio.setMesage( 0, {
        severity: 'info', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'PRODUCTOREFERENCIA.MSG_MARCARUNO' )
      } );
      return false;
    }else{
      return true;
    }
  }

  verificarNuevas( idTipoReferencia: string[], idProductoVinculacionMinimo: string, nroReferencia: number, registros: ProductoVinculacionMinimoReferencia[], analizamos: boolean, digital: boolean,mensaje: number ) {
    const a = this.validarCreacionReferencias( analizamos, digital, idTipoReferencia, idProductoVinculacionMinimo, registros );
    if ( a.length > 0 ) {
      this.serProductoVinculacionMinimoReferencia.bulk( a ).subscribe( reg => {
        this.actualizarMinimas( mensaje );
      } );
    } else {
      const val = this.proVinculacionesMinimas.find( x => x.idProductoVinculacionMinimo === idProductoVinculacionMinimo );
      if ( val ) {
        val.indicadorCanalAnalizamos = analizamos;
        val.indicadorCanalDigital = digital;
        val.nroReferencias = nroReferencia;
        val.indicadorHabilitado = true;
      }
      this.salir( mensaje );
    }
  }

  formatearMinimaReferenciaObjetoBulkCreacion(analizamos: boolean, digital: boolean, idsReferencias: string[], idProductoVinculacionMinimo: string ) {
    let objReferencias: ProductoVinculacionMinimoReferencia[] = [];
    idsReferencias.map( ( z: string ) => {
      let nuevoRegistro = {} as ProductoVinculacionMinimoReferencia;
      nuevoRegistro.idTipoReferencia = z;
      nuevoRegistro.indicadorCanalAnalizamos = analizamos;
      nuevoRegistro.indicadorCanalDigital = digital;
      nuevoRegistro.indicadorHabilitado = true;
      nuevoRegistro.idProductoVinculacionMinimo = idProductoVinculacionMinimo;
      objReferencias.push( nuevoRegistro );
    } );
    return objReferencias;
  }


  validarCreacionReferencias(analizamos:boolean, digital:boolean, idsReferencias: string[], idProductoVinculacionMinimo: string, lisProductoVinculacionesMinimaReferencia: ProductoVinculacionMinimoReferencia[] ) {
    let objReferencias: ProductoVinculacionMinimoReferencia[] = [];
    idsReferencias.map( ( z: string ) => {
      const a = lisProductoVinculacionesMinimaReferencia.find( x => x.idTipoReferencia === z );
      if ( a && !a.indicadorHabilitado ) {
        a.indicadorHabilitado = true;
        objReferencias.push( a );
      } else if ( !a ) {
        let nuevoRegistro = {} as ProductoVinculacionMinimoReferencia;
        nuevoRegistro.idTipoReferencia = z;
        nuevoRegistro.indicadorCanalDigital = digital;
        nuevoRegistro.indicadorCanalAnalizamos = analizamos;
        nuevoRegistro.indicadorHabilitado = true;
        nuevoRegistro.idProductoVinculacionMinimo = idProductoVinculacionMinimo;
        objReferencias.push( nuevoRegistro );
      }
    } );
    lisProductoVinculacionesMinimaReferencia.map( ( a: ProductoVinculacionMinimoReferencia ) => {
      if ( a.indicadorHabilitado && !idsReferencias.find( x => x === a.idTipoReferencia ) ) {
        a.indicadorHabilitado = false;
        objReferencias.push( a );
      }
    } );
    return objReferencias;
  }

  validarNumeroReferencias( idVinculacion: string, idTipoUsoTelefono: string, idsReferencias: string[], numeroReferenciaMinima: number ) {
    let numReferencia: number = 0;
    idsReferencias.map( ( s: string ) => {
      const reg = this.lisProductosReferencias.find( x => x.idTipoVinculacion === idVinculacion && x.idTipoUsoTelefono === idTipoUsoTelefono && x.idTipoReferencia === s && x.indicadorHabilitado );
      if ( reg ) {
        numReferencia += reg.numeroReferencias;
      }
    } );
    return (Number( numeroReferenciaMinima ) <= numReferencia);
  }

  formatearMinimasReferencias() {
    this.proVinculacionesMinimas.map( ( x: ProductoVinculacionMinimo ) => {
      if ( x.indicadorHabilitado ) {
        let nombres = '';
        x.referencias.map( ( s: ProductoVinculacionMinimoReferencia ) => {
          if ( s.indicadorHabilitado ) {
            nombres += s.nombreTipoReferencia + ',';
          }
        } );
        x.nombresReferencias = nombres ? nombres.substring( 0, nombres.length - 1 ) : nombres;
      }
    } );
  }

  registrosHabilitados() {
    this.proVinculacionesMinimasHabilitados = [ ...this.proVinculacionesMinimas.filter( z => z.indicadorHabilitado ) ];
    this.proVinculacionesMinimasHabilitados.forEach(x => {
      if (Array.isArray(x.naturaleza) && x.naturaleza.length > 0) {
        const lista = x.naturaleza.filter(l =>l.indicadorHabilitado ).map(l => l.tipoPersona);
        x.tipoPersona = lista.join(',');

      }
    })
  }

  actualizarMinimas( mensaje: number ) {
    this.proVinculacionesMinimas = [];
    this.serProductoVinculacionMinimo.listadoPorProductoTodos( this.producto.idProducto ).subscribe( registros => {
      this.proVinculacionesMinimas = registros;
      this.registrosHabilitados();
      this.salir( mensaje );
    } );
  }

  cargarTipoUsoCelular() {
    this.lisTipoUsoCelular = [];
    this.f.idTipoUsoTelefono.setValue( null );
    this.lisProductosReferencias.map( ( s: ProductoReferencia ) => {
      if ( s.idTipoVinculacion === this.f.idTipoVinculacion.value && !this.lisTipoUsoCelular.find( y => y.value === s.idTipoUsoTelefono ) ) {
        this.lisTipoUsoCelular.push( { label: s.nombreTipoUsoCelular, value: s.idTipoUsoTelefono } );
      }
    } );
  }

  cargarReferencias() {
    this.lisReferencias = [];
    const id = this.f.idTipoVinculacion.value ;
    const idTipoCelular = this.f.idTipoUsoTelefono.value;
    if ( id && idTipoCelular ) {
      const minimo = this.proVinculacionesMinimas.filter( e => e.idTipoVinculacion === id && e.idTipoUsoTelefono === idTipoCelular && e.indicadorHabilitado );
      const refConfig = this.lisProductosReferencias.filter( z => z.idTipoVinculacion === id && z.idTipoUsoTelefono === idTipoCelular && z.indicadorHabilitado );
      let minimoReferencias: ProductoVinculacionMinimoReferencia[] = [];
      if ( minimo && minimo.length > 0 ) {
        minimo.map( ( q: ProductoVinculacionMinimo ) => {
          minimoReferencias = minimoReferencias.concat( q.referencias.filter( x => x.indicadorHabilitado ) );
        } );
        this.lisReferenciaTodos.map( ( s: ListaItem ) => {
          if ( refConfig.find( y => y.idTipoReferencia === s.idLista ) && !minimoReferencias.find( g => g.idTipoReferencia === s.idLista && (!this.proVinculacionMinimoSeleccionado || this.proVinculacionMinimoSeleccionado.idProductoVinculacionMinimo !== g.idProductoVinculacionMinimo) ) ) {
            this.lisReferencias.push( { label: s.nombre, value: s.idLista } );
          }
        } );
      } else {
        this.lisReferenciaTodos.map( ( s: ListaItem ) => {
          if ( refConfig.find( y => y.idTipoReferencia === s.idLista ) ) {
            this.lisReferencias.push( { label: s.nombre, value: s.idLista } );
          }
        } );
      }
    }

    const nueListado = [];
    (this.f.idTipoReferencia.value ? this.f.idTipoReferencia.value : []).map( ( s: number ) => {
      if ( this.lisReferencias.find( x => x.value === s ) ) {
        nueListado.push( s );
      }
    } );
    this.f.idTipoReferencia.setValue( nueListado );


  }


  editar( registro: ProductoVinculacionMinimo ) {
    this.proVinculacionMinimoSeleccionado = registro;
    this.f.idTipoVinculacion.setValue( this.proVinculacionMinimoSeleccionado.idTipoVinculacion );
    this.cargarFormulario();
    this.cargarReferencias();
  }

  salir( mensaje: number ) {
    this.proVinculacionMinimoSeleccionado = null;
    this.lisReferencias = [];
    this.lisTipoUsoCelular = [];
    this.cargarVinculaciones();
    this.formatearMinimasReferencias();
    this.cargarFormulario();
    this.submitted = false;
    this.guardando = false;
    this.carTabla = false;
    this.carInformacionInicial = false;
    if ( mensaje !== null && mensaje !== undefined ) {
      this.navServicio.setMesage( mensaje );
    }

  }

  setBusqueda() {
    this.navServicio.setSearch( 'producto-referencia-minima.component', this.busqueda );
  }

  inhabilitar( registro: ProductoVinculacionMinimo ) {
    this.guardando = true;
    this.carTabla = true;
    this.conServicio.confirm( {
      message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
      header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
      icon: 'fa fa-question-circle',
      key: 'referencias-minima',
      accept: () => {
        this.carInformacionInicial = true;
        registro.indicadorHabilitado = false;
        this.serProductoVinculacionMinimo.actualizar( registro ).subscribe(async regActualizado => {
          if (Array.isArray(registro.naturaleza) && registro.naturaleza.length > 0) {
            registro.naturaleza.forEach(l=> {
              l.indicadorHabilitado = false;
            });
            await this.productosVinculacionesMinimoTiposPersonas.bulk(registro.naturaleza).toPromise();
          }
          this.cargarVinculaciones();
          this.actualizarMinimas( 2 );
        } );
      },
      reject: () => {
        this.guardando = false;
        this.carTabla = false;
      }
    } );
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'referencias-minima',
        accept: () => {
          this.salir( null );
        },
        reject: () => {
        }
      } );
    } else {
      this.salir( null );
    }
  }

}
